export default "__VITE_ASSET__Bvuh71En__"